export type ViewWindow = { start: number; span: number };
export function timeAtFraction(
  view: ViewWindow,
  fraction: number,
  duration: number,
) {
  return Math.max(
    0,
    Math.min(
      duration,
      view.start + Math.max(0, Math.min(1, fraction)) * view.span,
    ),
  );
}
export function waveformBins(
  peaks: { bin_ms: number; duration_ms: number; peaks: number[] } | null,
  view: ViewWindow,
  count: number,
) {
  return Array.from({ length: count }, (_, i) => {
    if (!peaks || peaks.bin_ms <= 0) return 0;
    const start = Math.max(
      0,
      Math.floor((view.start + (i / count) * view.span) / peaks.bin_ms),
    );
    const end = Math.min(
      peaks.peaks.length,
      Math.ceil(
        Math.min(
          peaks.duration_ms,
          view.start + ((i + 1) / count) * view.span,
        ) / peaks.bin_ms,
      ),
    );
    let peak = 0;
    for (let n = start; n < end; n++) peak = Math.max(peak, peaks.peaks[n]);
    return peak / 255;
  });
}
export function clampView(
  start: number,
  span: number,
  duration: number,
): ViewWindow {
  const total = Math.max(1, duration);
  const width = Math.min(total, Math.max(Math.min(5000, total), span));
  return { start: Math.max(0, Math.min(start, total - width)), span: width };
}
export function zoomView(
  view: ViewWindow,
  factor: number,
  anchor: number,
  duration: number,
) {
  const fraction = Math.max(0, Math.min(1, (anchor - view.start) / view.span));
  const span = clampView(0, view.span / factor, duration).span;
  return clampView(anchor - fraction * span, span, duration);
}
export function bandcampSearch(artist: string, title: string) {
  return artist.trim() && title.trim()
    ? `https://bandcamp.com/search?q=${encodeURIComponent(`${artist.trim()} ${title.trim()}`)}`
    : null;
}
